<section class="team-section">
  <div class="container">
    <!-- Section Title -->
    <div class="section-title mb-40 both-border text-center">
      <span class="title-tag" *transloco="let t; read: 'home'">{{
        t("team")
      }}</span>
      <h2 class="title" *transloco="let t; read: 'home'">
        {{ t("title_team") }}
      </h2>
    </div>

    <!-- Team Boxes -->
    <ngx-slick-carousel
      #slickModal="slick-carousel"
      [config]="settings"
      class="row team-members"
      id="teamSliderOne"
      *transloco="let t"
    >
      <div
        ngxSlickItem
        class="col-lg-3"
        *ngFor="let item of teamblock; let i = index"
      >
        <div class="team-member" data-aos="fade-up">
          <ng-container>
            <div class="member-picture-wrap">
              <div class="member-picture">
                <img
                  [src]="item.img"
                  [alt]="item.id == t('team')[i].id ? t('team')[i].name : ''"
                />
                <div class="social-icons hide-social-icons">
                  <p class="text-white">
                    {{ item.id == t("team")[i].id ? t("team")[i].name : "" }}
                  </p>
                </div>
              </div>
            </div>
            <div class="member-desc">
              <h5>
                <a>{{ item.id == t("team")[i].id ? t("team")[i].name : "" }}</a>
              </h5>
              <span>{{
                item.id == t("team")[i].id ? t("team")[i].position : ""
              }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </ngx-slick-carousel>
  </div>
</section>
